/**
 * list of pesisted store
 */
export const AUTHSTORE = "auth";
